export interface ThriveMarkerResult {
  hasResult: boolean;
  range: string;
}

export interface ThrivePanel {
  bmi: ThriveMarkerResult;
  a1c: ThriveMarkerResult;
  apoB: ThriveMarkerResult;
  crp: ThriveMarkerResult;
  bpSystolic: ThriveMarkerResult;
  bpDiastolic: ThriveMarkerResult;
}

export interface ThriveRecommendationRequest {
  panel: ThrivePanel;
  ecid?: string;
  surface?: string;
}

/** Card fields from Adobe `data.content` (Web SDK harness contract). */
export interface ThriveRecommendation {
  sourceId: string;
  title: string;
  contentType: string;
  imageUrl: string;
  /** Editorial teaser — prefer for "Teaser Content". */
  summary?: string;
  /** Snippet (~300 chars) — "Beginning of article" on the featured card. */
  body?: string;
  /** Consumer-facing topic label (e.g. "Blood Pressure") for UI meta lines. */
  consumerFriendlyName?: string;
  tags?: string[];
  conditions?: string[];
  coreHealthBehaviors?: string[];
  propositionId?: string;
  scope?: string;
}

export interface ThriveStateEntry {
  key: string;
  value: string;
  maxAge?: number;
}

export interface ThrivePropositionRef {
  id: string;
  scope: string;
  scopeDetails?: unknown;
}

export interface ThriveRecommendationResponse {
  recommendations: ThriveRecommendation[];
  sentinelOnly: boolean;
  /** Response-level AEM deep link for the whole set (`…#items=id1,id2`). */
  contentPageUrl?: string;
  propositions: ThrivePropositionRef[];
  stateEntries: ThriveStateEntry[];
  interactionTokens: string[];
}

export interface ThriveNotificationRequest {
  kind: 'display' | 'interact';
  label?: string;
  ecid?: string;
  propositions: ThrivePropositionRef[];
  stateEntries: ThriveStateEntry[];
  interactionTokens: string[];
}

export function emptyThriveMarker(): ThriveMarkerResult {
  return { hasResult: false, range: '' };
}

export function emptyThrivePanel(): ThrivePanel {
  return {
    bmi: emptyThriveMarker(),
    a1c: emptyThriveMarker(),
    apoB: emptyThriveMarker(),
    crp: emptyThriveMarker(),
    bpSystolic: emptyThriveMarker(),
    bpDiastolic: emptyThriveMarker(),
  };
}
